module.exports = __webpack_public_path__ + "47688bbf8227b6f8c79b23e9bdc6345d.pdf";